module.exports = {
      id: "mode-polygon-usage",
      viewBox: "0 0 24 22",
      url: __webpack_public_path__ + "img/icons.a7e6c507.svg#mode-polygon-usage",
      toString: function () {
        return this.url;
      }
    }